import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ValidationComponent } from '../../validation/validation.component';
import { CommonModule } from '@angular/common';
import { IDetailedReportSearch } from '../models/detailed-report-search.model';
import { DetailedReportValidator } from './detailed-report.validatior';
import { Location } from '@angular/common';
import { DetailedReportGridComponent } from "../detailed-report-grid/detailed-report-grid.component";
import { IDetailedReportGrid } from '../models/detailed-report-grid.model';
import { MatDialog } from '@angular/material/dialog';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { SearchRequestService } from '../../manage-request/services/search-request.service';
import { RequestStatuses, requestStatusesMapping } from '../../manage-request/models/request-status.model';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PersonSearchComponent } from '../../shared/person-search/person-search.component';
import { IPerson } from '../../models/person.model';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';

export type DetailedReportControls = {
  [K in keyof IDetailedReportSearch]: FormControl<string>;
};

@Component({
  selector: 'app-detailed-report',
  standalone: true,
  imports: [
    MatIconModule,
    ReactiveFormsModule, 
    ValidationComponent, 
    CommonModule, 
    DetailedReportGridComponent, 
    MatAutocompleteModule,
    PersonSearchComponent
  ],
  templateUrl: './detailed-report.component.html',
  styleUrl: './detailed-report.component.scss'
})
export class DetailedReportComponent{
  title = 'Detailed Report';
  isReportRight: boolean = false;
  validationMessages = [];
  divisionsList = [];
  requestStatusesList = [];
  requestStatusesMapping = requestStatusesMapping;
  requestTypesList = [];
  searchForm: FormGroup<DetailedReportControls> = this.createDetailedReportForm();
  data: PagedResult<IDetailedReportGrid[]>;
  user: ILoggedInUser;
  
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private validator: DetailedReportValidator,
    private searchRequestService: SearchRequestService,
    private dialog: MatDialog,
    private userService: LoggedInUserService
  ) {
  }
 
  ngOnInit() {
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user !== null && this.user.reportRight) {
        this.isReportRight = this.user.reportRight;
        this.loadData(); 
      }      
    });
  }

  loadData(){
    this.searchRequestService.getAllDivisions().subscribe({
      next: (data) => {
        this.divisionsList = data;
      },
      error: (error) => {
      },
    });

    this.searchRequestService.getAllRequestTypes().subscribe({
      next: (data) => {
        this.requestTypesList = data;
      },
      error: (error) => {
      },
    });
        
    this.requestStatusesList = Object.values(RequestStatuses);
  }
  
  private createDetailedReportForm(): FormGroup<DetailedReportControls> {
    return this.fb.group<DetailedReportControls>({
      requestFrom: new FormControl(''),
      requestTo: new FormControl(''),
      requestDateFrom: new FormControl(''),
      requestDateTo: new FormControl(''),
      division: new FormControl(''),
      chargeAfeCc: new FormControl(''),
      requestStatus: new FormControl(''),
      requestType: new FormControl(''),
      employee: new FormControl(''),
      approvedBy: new FormControl(''),
      approvedDateFrom: new FormControl(''),
      approvedDateTo: new FormControl(''),
    }, 
    { 
      validators: [this.validator.atLeastOneFieldRequired()]
    });      
  }

  private createDetailedReportSearchModel(): IDetailedReportSearch {
    return {
      requestFrom: Number(this.searchForm.get('requestFrom').value),
      requestTo: Number(this.searchForm.get('requestTo').value),
      requestDateFrom: new Date(this.searchForm.get('requestDateFrom').value),
      requestDateTo: new Date(this.searchForm.get('requestDateTo').value),
      division: this.searchForm.get('division').value,
      chargeAfeCc: this.searchForm.get('chargeAfeCc').value,
      requestStatus: this.searchForm.get('requestStatus').value,
      requestType: this.searchForm.get('requestType').value,
      employee: this.searchForm.get('employee').value,
      approvedBy: this.searchForm.get('approvedBy').value,
      approvedDateFrom: new Date(this.searchForm.get('approvedDateFrom').value),
      approvedDateTo: new Date(this.searchForm.get('approvedDateTo').value),
    };
  }

  onEmployeeSelected(person: IPerson){
    this.searchForm.get('employee').patchValue(person.id.toString());
  }

  onEmployeeClear(){
    this.searchForm.get('employee').setValue('');
  }

  onApproverSelected(person: IPerson){
    var searchPhrase = person.surName + ", " + person.firstName;
    this.searchForm.get('approvedBy').setValue(searchPhrase);
  }

  onApproverClear(){
    this.searchForm.get('approvedBy').setValue('');
  }

  submitForm(): void {    
    if (this.searchForm.valid && this.user !== null) {
      this.validationMessages = [];
      var searchParams = new SearchParameters<IDetailedReportSearch>();
      searchParams.query =  this.createDetailedReportSearchModel();

      this.openModal(searchParams);
    } else {
      this.validationMessages.push(this.searchForm.errors?.atLeastOneFieldRequired);
    }
  }
  
  openModal(searchParams: SearchParameters<IDetailedReportSearch>): void {
    this.dialog.open(DetailedReportGridComponent,{
      data: searchParams
    });    
  }

  goBack(): void {
    this.location.back();
  }
}
